import { Center, Image, Text } from "@chakra-ui/react";
import React from "react";
import ConversationMedia from "../../../components/molecules/ai-tutor/ConversationMedia";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import RelatedContent from "../../../assets/ai-tutor/related-content.svg";
import styles from "./practice-media.module.css";

/**
 * Component for displaying related content in the practice sidebar with toggle functionality
 * @param {Object} props - Component props
 * @param {Array} props.mediaDetails - Array of media items to display
 * @param {Function} props.handleShowMedia - Function to handle when media is clicked
 * @param {boolean} props.openRelatedContent - Whether the related content panel is open
 * @param {Function} props.toggleRelatedContent - Function to toggle the panel open/closed
 * @param {boolean} props.isMobile - Whether the device is a mobile device
 */
const PracticeMedia = ({
  mediaDetails,
  handleShowMedia,
  openRelatedContent,
  toggleRelatedContent,
  isMobile
}) => {
  const mediaMenuStyle = `${styles["media-menu"]} ${mediaDetails?.length > 0 ? styles["drawer-open"] : ""}`;

  return (
    <>
      {/* Only show the toggle button outside the panel when it's closed or on desktop */}
      {(!openRelatedContent || !isMobile) &&
      <Center
        position="fixed"
        right={openRelatedContent ? "260px" : "10px"}
        zIndex="2000"
        cursor="pointer"
        onClick={toggleRelatedContent}
        bg="white"
        borderRadius="8px"
        boxShadow="0px 2px 6px rgba(0, 0, 0, 0.3)"
        w="36px"
        height="36px"
        transition="right 0.3s ease-in-out, background 0.2s ease-in-out"
        _hover={{ bg: "#f0f0f0" }}
        sx={isMobile ?
        { "bottom": "120px", left: openRelatedContent ? "10px" : "85%" } :
        { top: "100px", right: openRelatedContent ? "260px" : "10px" }}>

          {openRelatedContent ?
        <BsChevronRight size={20} color="#444" /> :

        isMobile ? <Image src={RelatedContent} /> : <BsChevronLeft size={20} color="#444" />
        }
        </Center>
      }

      {openRelatedContent &&
      <div className={mediaMenuStyle}>
          {/* Fixed header */}
          <div className={isMobile ? styles["media-menu-header"] : ""}>
            <Text color={"#1D287A"} fontSize={"16px"} fontWeight={"600"}>
              Related content
            </Text>
          </div>

          {/* Scrollable content area */}
          <div className={isMobile ? styles["media-menu-content"] : ""} style={!isMobile ? { overflowY: "auto", flex: 1 } : {}}>
            <ConversationMedia
            mediaDetails={mediaDetails || []}
            handleShowMedia={handleShowMedia} />

          </div>

          {/* Fixed footer with close button on mobile */}
          {isMobile &&
        <div className={styles["media-menu-footer"]}>
              <Center
            w="36px"
            h="36px"
            bg="#FFFFFF"
            borderRadius="8px"
            boxShadow="0px 2px 6px rgba(0, 0, 0, 0.3)"
            height="36px"
            cursor="pointer"
            onClick={toggleRelatedContent}>

                <BsChevronRight size={20} color="#444" />
              </Center>
            </div>
        }
        </div>
      }
    </>);

};

export default PracticeMedia;